module.exports = require("./scripts/index.js");


//////////////////
// WEBPACK FOOTER
// ./collection-institutional-portal/src/widgets/widget-loading/model.xml
// module id = 0
// module chunks = 15